import { useEffect, useState } from 'react';
import ApexLogo from './ApexLogo';
import { Icons } from './Icons';
import { LINKS } from '../constants';
import { useInView } from '../hooks';
import styles from './Hero.module.css';

function StatPill({ value, label }) {
  return (
    <div className={styles.pill}>
      <span className={styles.pillValue}>{value}</span>
      <span className={styles.pillLabel}>{label}</span>
    </div>
  );
}

function OrbitalLogo() {
  const [angle1, setAngle1] = useState(0);
  const [angle2, setAngle2] = useState(180);

  useEffect(() => {
    let id;
    const tick = () => {
      setAngle1(a => (a + 0.18) % 360);
      setAngle2(a => (a - 0.12 + 360) % 360);
      id = requestAnimationFrame(tick);
    };
    id = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(id);
  }, []);

  const pos = (angle, r) => ({
    x: 50 + r * Math.cos((angle * Math.PI) / 180),
    y: 50 + r * Math.sin((angle * Math.PI) / 180),
  });

  const d1 = pos(angle1, 47);
  const d2 = pos(angle2, 41);

  return (
    <div className={styles.orbital}>
      <svg viewBox="0 0 100 100" className={styles.orbitalSvg}>
        <circle cx="50" cy="50" r="47" fill="none" stroke="rgba(59,130,246,0.14)" strokeWidth="0.5" />
        <circle cx="50" cy="50" r="41" fill="none" stroke="rgba(6,182,212,0.10)"  strokeWidth="0.5" />
        <circle cx="50" cy="50" r="34" fill="none" stroke="rgba(255,255,255,0.04)" strokeWidth="0.5" />
        <circle cx={d1.x} cy={d1.y} r="1.2" fill="#06B6D4" style={{ filter: 'drop-shadow(0 0 3px #06B6D4)' }} />
        <circle cx={d2.x} cy={d2.y} r="1.0" fill="#3B82F6" style={{ filter: 'drop-shadow(0 0 3px #3B82F6)' }} />
      </svg>
      <div className={styles.logoCenter}>
        <ApexLogo size={160} glow={true} />
      </div>
    </div>
  );
}

export default function Hero({ t }) {
  const [ref, inView] = useInView(0.1);

  return (
    <section className={styles.section} id="top">
      <div className={styles.glow} />
      <div className={styles.inner}>
        <div
          ref={ref}
          className={styles.content}
          style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(24px)', transition: 'all 0.7s ease' }}
        >
          <div className={styles.eyebrow}>{t.eyebrow}</div>
          <h1 className={styles.title}>
            {t.title1}<br />
            <span className={styles.gradient}>{t.title2}<br />{t.title3}</span>
          </h1>
          <p className={styles.sub}>{t.sub}</p>
          <div className={styles.actions}>
            <a href={LINKS.buy} target="_blank" rel="noopener noreferrer" className={styles.btnPrimary}>
              {t.buyBtn} <Icons.Arrow />
            </a>
            <a href={LINKS.dex} target="_blank" rel="noopener noreferrer" className={styles.btnGhost}>
              {t.dexBtn} <Icons.ExternalLink />
            </a>
          </div>
          <div className={styles.stats}>
            <StatPill value={t.stat1Value} label={t.stat1Label} />
            <StatPill value={t.stat2Value} label={t.stat2Label} />
            <StatPill value={t.stat3Value} label={t.stat3Label} />
          </div>
        </div>

        <div
          className={styles.visual}
          style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'scale(0.92)', transition: 'all 0.9s ease 0.2s' }}
        >
          <OrbitalLogo />
        </div>
      </div>
    </section>
  );
}
